import styled from 'styled-components';

const StyledWrapper = styled.aside`
  display: block;
  flex-shrink: 0;
`;

export { StyledWrapper };
